import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-217456e8")

_pushScopeId("data-v-217456e8")
const _hoisted_1 = { class: "custom-select" }
const _hoisted_2 = { class: "select-box" }
const _hoisted_3 = { class: "commands" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.show && _ctx.show(...args))),
      disabled: _ctx.disabled
    }, [
      _renderSlot(_ctx.$slots, "default", {
        item: _ctx.selectedValue,
        isdrop: false
      }, undefined, true),
      _createVNode(_component_fa, {
        class: "thumb",
        icon: ['fas', 'caret-down']
      })
    ], 8, ["disabled"]),
    _withDirectives(_createVNode("div", {
      ref: "selectWrap",
      class: "select-wrap",
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      tabindex: "1"
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
            return (_openBlock(), _createBlock("button", {
              key: i,
              onClick: ($event: any) => (_ctx.clickHook(() => _ctx.context.emit('update:selectedValue', item))),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.context.emit('focus')))
            }, [
              _renderSlot(_ctx.$slots, "default", { item, isDropItem: true }, undefined, true)
            ], 40, ["onClick"]))
          }), 128))
        ])
      ])
    ], 544), [
      [_vShow, _ctx.isShow]
    ])
  ]))
})